__turbopack_context__.v({
  "cancelButton": "_DRnLq_cancelButton",
  "checkIcon": "_DRnLq_checkIcon",
  "complete": "_DRnLq_complete",
  "container": "_DRnLq_container",
  "error": "_DRnLq_error",
  "errorState": "_DRnLq_errorState",
  "percentage": "_DRnLq_percentage",
  "progressBar": "_DRnLq_progressBar",
  "progressBarContainer": "_DRnLq_progressBarContainer",
  "progressHeader": "_DRnLq_progressHeader",
  "progressSection": "_DRnLq_progressSection",
  "shimmer": "_DRnLq_shimmer",
  "slideIn": "_DRnLq_slideIn",
  "spin": "_DRnLq_spin",
  "spinner": "_DRnLq_spinner",
  "statusRow": "_DRnLq_statusRow",
  "statusText": "_DRnLq_statusText",
  "urlRow": "_DRnLq_urlRow",
  "urlText": "_DRnLq_urlText",
  "validBadge": "_DRnLq_validBadge",
});
